document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener("click", function(e) {
        if (e.target.matches(".js-slideToggle")) {
            e.preventDefault();
            e.target.classList.toggle("is-active");
            const targetSelectorAttr = e.target.getAttribute("data-target");
            const target = document.querySelector(targetSelectorAttr);
            slideToggle(target);
        }
    });
});

function slideToggle(element, duration) {
    duration = typeof duration !== "undefined" ? duration : 400;
    element.style.overflow = "hidden";
    var isSlidingDown = window.getComputedStyle(element).display === "none";

    if (isSlidingDown) {
        element.style.height = "0px";
        element.style.display = "block";
    }

    var height = element.scrollHeight;
    var start = Date.now();

    var step = function(isSlidingDown) {
        var elapsed = Date.now() - start;
        var progress = elapsed / duration;
        element.style.height = (isSlidingDown ? progress : 1 - progress) * height + "px";

        if (elapsed < duration) {
            requestAnimationFrame(function() {
                step(isSlidingDown);
            });
        } else {
            element.style.height = "";
            if (!isSlidingDown) {
                element.style.display = "none";
            }
        }
    };

    requestAnimationFrame(function() {
        step(isSlidingDown);
    });
}